/* eslint-disable max-lines-per-function */
import { get } from 'axios';

export const getTransportDates = async (bookingRef, routes, direction) => {
  const { data } = await get(`/api/package/${bookingRef}/transportdates`, {
    params: {
      routes,
      direction,
    },
  });

  return data;
};

export const getTransportLocations = async (
  bookingRef,
  routes,
  date,
  direction,
) => {
  const { data } = await get(`/api/package/${bookingRef}/transportlocations`, {
    params: {
      date,
      direction,
      routes,
    },
  });

  return data;
};

export const getTransportStops = async (
  bookingRef,
  routes,
  date,
  departureLocation,
  arrivalLocation,
  direction,
) => {
  const { data } = await get(`/api/package/${bookingRef}/transportstops`, {
    params: {
      arrivalLocation,
      date,
      departureLocation,
      routes,
      direction,
    },
  });

  return data;
};

export const getTransportRoutes = async bookingRef => {
  const { data } = await get(`/api/package/${bookingRef}/transportroutes`);

  return data;
};
